<template>
    <div class="warning" v-if="store.message !== null" v-bind:class="{ error: store.messageType == 'error', success: store.messageType == 'success' }">
        <div class="message">
            <div class="top">
                <div class="title" v-if="store.messageType == 'error'">Ошибка</div>
                <div class="title" v-if="store.messageType == 'success'">Сообщение</div>
                <a class="close" @click="store.closeMessage()" v-if="store.messageType == 'error'">&times;</a>
                <a class="close" @click="closeAll" v-if="store.messageType == 'success'">&times;</a>
            </div>
            <div class="content">
                <div class="icon">
                    <img src="../../../../assets/warning.svg" v-if="store.messageType == 'error'">
                    <img src="../../../../assets/success.svg" v-if="store.messageType == 'success'">
                </div>
                <div class="text">
                    {{store.message}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["store"],
        methods: {
            closeAll: function(){
                this.store.closeMessage();
                this.store.stateFull(false);
            }
        }
    }
</script>

<style lang="scss">
    #yacurier-form{
        .full-form{
            .warning{
                align-items: center;
                background: rgba(0,0,0,.5);
                bottom: 0;
                display: flex;
                justify-content: center;
                left: 0;
                position: fixed;
                right: 0;
                top: 0;
                z-index: 1001;
                .message{
                    background: #FFF;
                    border: 1px solid #f2f6fc;
                    box-shadow: 0 0 20px 0 rgba(164, 182, 206, .5);
                    max-width: 500px;
                    position: relative;
                    .top{
                        align-items: center;
                        background: #FBFCFB;
                        border-bottom: 1px solid #D0D5E0;
                        display: flex;
                        padding: 10px 20px;
                        .title{
                            flex-grow: 1;
                            flex-shrink: 0;
                            font-size: 14px;
                            font-weight: bold;
                        }
                        .close{
                            background: none;
                            border: none;
                            color: #333;
                            cursor: pointer;
                            flex-grow: 0;
                            flex-shrink: 1;
                            font-size: 20px;
                            margin-left: 20px;
                            opacity: .45;
                            &:hover{
                                opacity: 1;
                            }
                        }

                    }
                    .content{
                        align-items: center;
                        display: flex;
                        padding: 20px;
                        .icon{
                            height: 40px;
                            margin-right: 20px;
                            width: 40px;
                        }
                        .text{
                            font-size: 14px;
                            font-weight: 600;
                        }
                    }
                }
                &.error{
                    .text{
                        color: #D93E40;
                    }
                }
                &.success{
                    .text{
                        color: #039600;
                    }
                }
            }

        }
    }
</style>


// WEBPACK FOOTER //
// src/components/blocks/FullForm/components/Warning.vue